import { config, loadConfig } from '../../../config/config';
import { ContextNavigate } from '../../shared/components/context-navigate/context-navigate';
import { usePromiseValue } from '../../shared/hooks/use-promise-value';
import type { FCWithChildren } from '../../shared/utils/component.interface';
import { getClient } from '../graphql';

// Outside to immediately invoke the geolocation check and to cache
// the resolved promise.

const geolocationPromise = loadConfig().then(() =>
    getClient()
        .query<{ isGeoLocationAllowed: { isAllowed: boolean } }, { xTenantID: string }>(
            `
query isGeoLocationAllowed($xTenantID: String!) {
    isGeoLocationAllowed(xTenantID: $xTenantID) {
        isAllowed
    }
}
`,
            {
                xTenantID: config.TENANT_ID,
            },
        )
        .toPromise(),
);

export const LocationGuard: FCWithChildren<unknown> = ({ children }) => {
    const isAllowed = usePromiseValue(geolocationPromise);

    if (isAllowed.resolving || !isAllowed.data) {
        return null;
    }

    if (isAllowed.data.data?.isGeoLocationAllowed.isAllowed === false) {
        return <ContextNavigate to="/restricted" />;
    }

    return <>{children}</>;
};
